import type { TcsRecommendationRepository } from "../../domain/repositories/TcsRecommendationRepository";
import type { TcsRecommendationEntity } from "../../domain/entities/TcsRecommendationEntity";
import { fetchTcsRecommendationByJobId } from "../api/tcsRecommendationApi";
import { mapTcsRecommendationDTOToEntity } from "../mappers/TcsRecommendationMapper";

export class TcsRecommendationRepositoryImpl implements TcsRecommendationRepository {
  async getByJobId(jobId: string): Promise<TcsRecommendationEntity | null> {
    const dto = await fetchTcsRecommendationByJobId(jobId);
    if (!dto) {
      return null;
    }
    return mapTcsRecommendationDTOToEntity(dto);
  }
}

export const tcsRecommendationRepository = new TcsRecommendationRepositoryImpl();
